import { render, staticRenderFns } from "./InvoiceRecipientCreateModal.vue?vue&type=template&id=52a11dd0&scoped=true&"
import script from "./InvoiceRecipientCreateModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceRecipientCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a11dd0",
  null
  
)

export default component.exports